import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MessagesContext from '../../contexts/messagesContext';
import closeMenu from '../../assets/images/logo/exist-from-patient-icon.svg';
import { Link } from 'react-router-dom';
import { Age, Gender } from '../UI';
import styles from './CustomSideBar.styles';
import { CloseIcon } from '../UI/Images/Icons';
import { LightTooltip } from '../SideBarRight';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../contexts/languageContext';

const CustomSideBar = ({ data, patient, title, handleClosePatient, isPatientPage = false }) => {
    const { messages } = useContext(MessagesContext);
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(() => {
        const open = localStorage.getItem('isOpen')
            ? JSON.parse(localStorage.getItem('isOpen'))
            : true;
        return open;
    });
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa', isOpen });

    const handleToggleSideBar = () => {
        localStorage.setItem('isOpen', !isOpen);
        setIsOpen(!isOpen);
    };

    return (
        <>
            <div className={classes.sidebarContainer}>
                {isPatientPage ? (
                    <div className={classes.patientSection}>
                        <div>
                            <LightTooltip
                                disableHoverListener={isOpen}
                                placement="left"
                                title={messages.closePatient}
                                arrow
                            >
                                <div className={classes.closeIconWrapper}>
                                    <CloseIcon
                                        onClick={() => handleClosePatient(patient)}
                                        className={classes.closeIcon}
                                        data-testid="closeIcon"
                                    />
                                </div>
                            </LightTooltip>
                        </div>
                        <div>
                            <div className={classes.optionWrapper}>
                                {patient?.first_name} {patient?.last_name}
                            </div>
                            <div className={classes.patientAge}>
                                {patient?.gender && <Gender height="22" gender={patient?.gender} />}
                                <div>{patient?.dob && <Age dob={patient.dob} />}</div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={classes.titleWrapper}>
                        <div className={classes.title}>{title}</div>
                    </div>
                )}
                <div className={classes.linksContainer}>
                    {data.map((item, index) => (
                        <LightTooltip
                            key={index}
                            disableHoverListener={isOpen}
                            placement="left"
                            title={item.label}
                            arrow
                        >
                            <div
                                // key={index}
                                className={`${
                                    location.pathname?.includes(item.name)
                                        ? classes.activeLinkContainer
                                        : ''
                                } ${classes.linkItemContainer}`}
                                // onClick={() => setActiveLink(link.component)}
                            >
                                <Link
                                    className={`${
                                        location.pathname?.includes(item.name) && classes.activeLink
                                    } ${classes.link}`}
                                    to={item.link}
                                >
                                    <img src={item.icon} />
                                    <span className={classes.linkLabel}>{item.label}</span>
                                </Link>
                            </div>
                        </LightTooltip>
                    ))}
                </div>
                <div className={classes.closeSection}>
                    <div onClick={handleToggleSideBar} data-testid="toggleSideBar">
                        {/* <CrossIcon className={classes.img} height="10" width="10" /> */}
                        {isOpen ? (
                            <>
                                <img src={closeMenu} className={classes.openMenuIcon} />
                                <span className={classes.closeMenuMessage}>
                                    {messages.closeMenu}
                                </span>
                            </>
                        ) : (
                            <LightTooltip placement="left" title={messages.openMenu} arrow>
                                <img src={closeMenu} className={classes.openMenuIcon} />
                            </LightTooltip>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
CustomSideBar.propTypes = {
    data: PropTypes.array,
    patient: PropTypes.object,
    title: PropTypes.string,
    isPatientPage: PropTypes.bool,
    handleClosePatient: PropTypes.func,
    commonPath: PropTypes.string
};
export default CustomSideBar;
